import NewActionForm from './NewActionForm'
import useTitle from '../../hooks/useTitle'
const NewAction = () => {
    useTitle('geshtop-Exercise: New Action')
   
    const content = <NewActionForm  />

    return content
}
export default NewAction